import { css, Flex, styled } from '@chilipiper/design-system'

export const StyledBookMeetingContainer = styled(Flex)`
  width: 100%;
  flex-direction: column;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadows['border/on-major']};
  background: ${({ theme }) => theme.colors['bg/section']};
`
export const customerColorCss = css`
  color: rgb(var(--primary-contrast-color));
  background-color: rgb(var(--primary-color));
`
